import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import MyLetterhead from '../../components/settings/MyLetterhead';

/**
 * Attorney-portal home for the letterhead profile.
 *
 * Attorneys sign in through Clerk and live in the /attorney/* chrome — they never
 * see the admin SettingsPage (Org / Law Firms / Team / API), so routing them there
 * to set a bar number would expose admin surfaces. This dedicated route renders
 * ONLY MyLetterhead inside the attorney chrome, so an attorney can set the
 * name / bar number that document generation (demand + sworn PoL) requires.
 * Mounted at /attorney/letterhead behind ProtectedAttorneyRoute.
 */
export default function AttorneyLetterheadPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-base">
      {/* Header — mirrors the AttorneyWorkDesk chrome */}
      <div className="px-6 py-5 border-b border-hairline">
        <div className="max-w-[1320px] mx-auto">
          <button
            onClick={() => navigate('/attorney/workdesk')}
            className="flex items-center gap-1.5 text-sm text-text-muted hover:text-text-primary transition-colors mb-2"
          >
            <ArrowLeft className="w-4 h-4" /> Work Desk
          </button>
          <div className="text-xs tracking-[1.4px] text-brand uppercase font-semibold mb-1">
            Attorney · Profile
          </div>
          <h1 className="font-serif text-2xl text-text-primary">My Letterhead</h1>
        </div>
      </div>

      {/* Content — MyLetterhead brings its own max-w-2xl centered card. */}
      <div className="p-6">
        <MyLetterhead />
      </div>
    </div>
  );
}
